import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}


/**
 * Tri alphabétique d'une liste d'items par `name` (français, insensible à la casse/accents).
 * Retourne un nouveau tableau, ne mute pas l'original.
 * Usage : `sortByName(products).map(...)` dans n'importe quelle dropdown produit/distributeur.
 */
export function sortByName(items, key = "name") {
  if (!Array.isArray(items)) return [];
  return [...items].sort((a, b) =>
    String(a?.[key] || "").localeCompare(String(b?.[key] || ""), "fr", { sensitivity: "base" })
  );
}
